import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, Teleport as _Teleport } from "vue"

const _hoisted_1 = { class: "bg-white px-2 sm:px-4 py-2.5 dark:bg-gray-900 fixed w-full z-20 top-0 left-0 border-b border-gray-200 dark:border-gray-600 backdrop-blur-md shadow-md" }
const _hoisted_2 = { class: "container flex items-center justify-between mx-auto" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("img", {
  src: "https://cdn-icons-png.flaticon.com/512/7958/7958424.png",
  class: "h-6 mr-3 sm:h-9",
  alt: "Vue Logo"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { class: "self-center text-xl font-semibold whitespace-nowrap dark:text-white brand-name" }, " Vue3 Blog Testing ", -1)
const _hoisted_5 = { class: "flex md:order-2" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "text-white ml-2 px-2 py-1 rounded-md bg-gradient-to-r from-green-500 to-blue-500"
}, " Add Post ", -1)
const _hoisted_8 = { key: 1 }
const _hoisted_9 = { class: "fixed inset-0 z-50 flex items-center justify-center overflow-x-hidden overflow-y-auto outline-none focus:outline-none backdrop-blur-sm" }
const _hoisted_10 = { class: "relative w-full max-w-md mx-auto rounded-md shadow-lg backdrop-blur-xl border-1 shadow-slate-800" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  d: "M6 18L18 6M6 6l12 12"
}, null, -1)
const _hoisted_12 = [
  _hoisted_11
]
const _hoisted_13 = { class: "relative flex flex-col w-full py-3 bg-white border-0 rounded-lg shadow-lg outline-none focus:outline-none opacity-95" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "fixed inset-0 z-40 bg-black opacity-25 backdrop-blur-lg" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("nav", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_router_link, {
        to: "/",
        class: "flex items-center"
      }, {
        default: _withCtx(() => [
          _hoisted_3,
          _hoisted_4
        ]),
        _: 1
      }),
      _createElementVNode("div", _hoisted_5, [
        (_ctx.auth)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _createVNode(_component_router_link, { to: "/posts/new" }, {
                default: _withCtx(() => [
                  _hoisted_7
                ]),
                _: 1
              }),
              _createElementVNode("button", {
                type: "button",
                class: "text-white ml-2 px-2 py-1 rounded-md bg-gradient-to-r from-green-500 to-blue-500 whitespace-nowrap",
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.signOut && _ctx.signOut(...args)))
              }, " Sign Out ")
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_8, [
              _createElementVNode("button", {
                type: "button",
                class: "text-white ml-2 px-2 py-1 rounded-md bg-gradient-to-r from-green-500 to-blue-500 whitespace-nowrap",
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.signUp && _ctx.signUp(...args))),
                "data-test": "sign-up"
              }, " Sign Up "),
              _createElementVNode("button", {
                type: "button",
                class: "text-white ml-2 px-2 py-1 rounded-md bg-gradient-to-r from-green-500 to-blue-500 whitespace-nowrap",
                onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.signIn && _ctx.signIn(...args)))
              }, " Sign In ")
            ]))
      ])
    ]),
    (_openBlock(), _createBlock(_Teleport, { to: "#modal" }, [
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, [
          (_openBlock(), _createElementBlock("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            fill: "none",
            viewBox: "0 0 24 24",
            "stroke-width": "1.5",
            stroke: "currentColor",
            class: "absolute top-0 right-0 z-50 block w-6 h-6 text-xl font-semibold text-white bg-green-500 rounded-full cursor-pointer hover:opacity-85",
            onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.hide && _ctx.hide(...args)))
          }, _hoisted_12)),
          _createElementVNode("div", _hoisted_13, [
            (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.component)))
          ])
        ])
      ]),
      _hoisted_14
    ]))
  ]))
}